"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVALID_CURRICULA_FOR_MY_LIBRARY = void 0;
exports.INVALID_CURRICULA_FOR_MY_LIBRARY = [
    'emds',
    'emcattx',
    'wwdr',
    'geodesdte',
    'phddte',
    'phdteks',
    'al',
    'ww',
    'wwdte',
    'wwfl',
    'wwor',
    'phdnat25',
];
